<section class="bg-white py-16 sm:py-20">

  <div class="mx-auto max-w-page px-4 sm:px-6 lg:px-8">

    <div class="border-y border-slate-200 py-10 sm:py-12">

      <div class="grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">

        <!-- Left -->
        <div class="flex flex-col gap-4">
          <p class="text-caption font-semibold uppercase tracking-[0.2em] text-slate-500">
            Built for fast-moving teams
          </p>

          <h2 class="max-w-xl text-h2 font-medium text-slate-950">
            Forms, workflows, and insights in one place
          </h2>
        </div>

        <!-- Right -->
        <div class="flex flex-col gap-8">
          <p class="max-w-2xl text-body1 leading-8 text-slate-600">
            Streamline data collection, simplify approvals,
            and use AI-generated insights to help teams make faster operational decisions.
          </p>

          <div class="flex flex-wrap gap-6">

            <div class="flex flex-col gap-1">
              <p class="text-h4 text-slate-950">
                5x
              </p>

              <p class="text-body3 text-slate-500">
                Faster setup
              </p>
            </div>

            <div class="flex flex-col gap-1">
              <p class="text-h4 text-slate-950">
                92%
              </p>

              <p class="text-body3 text-slate-500">
                Approval efficiency
              </p>
            </div>

            <div class="flex flex-col gap-1">
              <p class="text-h4 text-slate-950">
                AI
              </p>

              <p class="text-body3 text-slate-500">
                Powered insights
              </p>
            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</section>
